import { WS_METHODS } from "@afar-research/contracts";
import { Atom } from "effect/unstable/reactivity";

import type { EnvironmentRegistry } from "../connection/registry.ts";
import { createEnvironmentRpcCommand, createEnvironmentRpcQueryAtomFamily } from "./runtime.ts";

export function createWorktreeEnvironmentAtoms<R, E>(
  runtime: Atom.AtomRuntime<EnvironmentRegistry | R, E>,
) {
  return {
    create: createEnvironmentRpcCommand(runtime, {
      label: "environment-command:worktrees:create",
      tag: WS_METHODS.worktreesCreate,
    }),
    available: createEnvironmentRpcQueryAtomFamily(runtime, {
      label: "environment-data:worktrees:available",
      tag: WS_METHODS.worktreesListAvailable,
      staleTimeMs: 5_000,
    }),
    managed: createEnvironmentRpcQueryAtomFamily(runtime, {
      label: "environment-data:worktrees:managed",
      tag: WS_METHODS.worktreesListManaged,
      staleTimeMs: 2_000,
    }),
    inspectManaged: createEnvironmentRpcCommand(runtime, {
      label: "environment-command:worktrees:inspect-managed",
      tag: WS_METHODS.worktreesListManaged,
    }),
    deleteOne: createEnvironmentRpcCommand(runtime, {
      label: "environment-command:worktrees:delete",
      tag: WS_METHODS.worktreesDelete,
    }),
    deleteProject: createEnvironmentRpcCommand(runtime, {
      label: "environment-command:worktrees:delete-project",
      tag: WS_METHODS.worktreesDeleteProject,
    }),
    deleteAll: createEnvironmentRpcCommand(runtime, {
      label: "environment-command:worktrees:delete-all",
      tag: WS_METHODS.worktreesDeleteAll,
    }),
    evidenceRecoveries: createEnvironmentRpcQueryAtomFamily(runtime, {
      label: "environment-data:worktrees:evidence-recoveries",
      tag: WS_METHODS.worktreesListEvidenceRecoveries,
      staleTimeMs: 2_000,
    }),
    restoreEvidence: createEnvironmentRpcCommand(runtime, {
      label: "environment-command:worktrees:restore-evidence",
      tag: WS_METHODS.worktreesRestoreEvidence,
    }),
    discardEvidence: createEnvironmentRpcCommand(runtime, {
      label: "environment-command:worktrees:discard-evidence",
      tag: WS_METHODS.worktreesDiscardEvidence,
    }),
  };
}
